import { createContext, useContext, useEffect, useState } from 'react'
import { getItem, setItem } from '../utils/storage'

const ThemeContext = createContext()

export function ThemeProvider ({ children }) {
  const [theme, setTheme] = useState(() => {
    const stored = getItem('theme')
    if (stored === 'light' || stored === 'dark') {
      return stored
    }

    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    return prefersDark ? 'dark' : 'light'
  })

  useEffect(() => {
    setItem('theme', theme)
    document.documentElement.dataset.theme = theme
  }, [theme])

  const toggleTheme = () => {
    setTheme(prev => (prev === 'light' ? 'dark' : 'light'))
  }

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  )
}

export function useTheme () {
  return useContext(ThemeContext)
}
